import $ from "jquery";
import imagesLoaded from "imagesloaded";

import SiteHeader from "./components/site-header";
import HomeSlider from "./components/home-slider";
import NewsSlider from "./components/news-slider";
import ReviewsSlider from "./components/reviews-slider";
import PartnersSlider from "./components/partners-slider";
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import Accordion from "./components/accordion";
import Gallery from "./components/gallery";
import ScrollInView from "./components/scroll-in-view";
import ProductsCatSlider from "./components/products-cat-slider";
import DeviceManager from "./utils/device-manager";
import RealisationsSlider from "./components/realisations-slider";
import "./components/product-videos";
import "./components/accessories-link";
import "./components/quantity";
import "./components/add-to-cart-button";
import "./components/products-filters";
import "./components/ajax-product";

// (function ($) {
// window.$ = $;

$(function () {
  const bootstrapApp = () => {
    const $html = $("html");

    // Touch device detection
    if (DeviceManager.isHandheld()) {
      $html.addClass("touch");

      if (DeviceManager.isIos()) {
        $html.addClass("ios");
      }
    } else {
      $html.addClass("no-touch");
    }

    // IE detection
    if (DeviceManager.isIe11()) {
      $html.addClass("ie11");
    } else if (DeviceManager.isEdge()) {
      $html.addClass("edge");
    }
  };

  const instanciateComponents = () => {
    // General components

    const siteHeader = new SiteHeader($(".site-header"), 20);

    // Home slider component
    const $homesSliders = $(".homepage-slider");
    if ($homesSliders.length) {
      $homesSliders.each(function (index, el) {
        const homeSlider = new HomeSlider($(el));
      });
    }

    // News slider component
    const $newsSliders = $(".news-list--slider");
    if ($newsSliders.length) {
      $newsSliders.each(function (index, el) {
        const newsSlider = new NewsSlider($(el));
      });
    }

    // Partners slider component
    const $partnersSliders = $(".partners-slider");
    if ($partnersSliders.length) {
      $partnersSliders.each(function (index, el) {
        const partnerSlider = new PartnersSlider($(el));
      });
    }

    // Products cat slider component
    const $productsCatSliders = $(".home-product-categories__slider");
    if ($productsCatSliders.length) {
      $productsCatSliders.each(function (index, el) {
        const productCatSlider = new ProductsCatSlider($(el));
      });
    }

    // Realisations slider component
    const $realisationsSliders = $(".home-realisations__slider");
    if ($realisationsSliders.length) {
      $realisationsSliders.each(function (index, el) {
        const realisationsSlider = new RealisationsSlider($(el));
      });
    }

    // Reviews slider component
    const $reviewsSlider = $(".reviews-slider");
    if ($reviewsSlider.length) {
      $reviewsSlider.each(function (index, el) {
        const reviewsSlider = new ReviewsSlider($(el));
      });
    }

    // Cookie consent
    if (typeof tarteaucitron !== "undefined" && tarteaucitron) {
      // Tarteaucitron cookie settings
      let tarteaucitronLang = "fr";

      const cookiesConsent = new CookiesConsent(tarteaucitronLang);
    }

    // Scroll in view component
    const $scrollInViewElements = $(".scroll-in-view");
    if ($scrollInViewElements.length) {
      $scrollInViewElements.imagesLoaded(function () {
        const scrollInView = new ScrollInView($scrollInViewElements);
      });
    }

    let cartNb = $(".cart-number.has-item");
    let cartMenu = $(".e-shop-button");
    cartNb.appendTo(cartMenu);
  };

  bootstrapApp();
  instanciateComponents();
});
// })(jQuery);

const $productForm = $('.variations_form');

if ($productForm.length) {
  const $priceEl = $('.js-variation-price');
  const originalPrice = $priceEl.html();

  $productForm.on('found_variation', function (e, variation) {
    if (variation.price_html) {
      $priceEl.html(variation.price_html + '<span class="taxes-excluded-ht">HT</span>');
    }
  });

  $productForm.on('reset_data', function () {
    $priceEl.html(originalPrice);
  });
}
